import { TRecommendation } from '../../types/recommendation';
import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export type TSetRecommendationsPayload = Array<TRecommendation>;

export enum ERecommendationsActionTypes {
  SetRecommendations = 'RECOMMENDATIONS / SET_RECOMMENDATIONS',
}

export type TRecommendationsActions = ITypedReduxAction<
  ERecommendationsActionTypes.SetRecommendations,
  TSetRecommendationsPayload
>;

export const setRecommendations: (payload: TSetRecommendationsPayload) => TRecommendationsActions = actionGenerator<
  ERecommendationsActionTypes.SetRecommendations,
  TSetRecommendationsPayload
>(ERecommendationsActionTypes.SetRecommendations);
